import cx from 'classnames'

import { useAppSelector } from 'common/hooks/redux'

import { ReactComponent as CrossedCircleIcon } from './icons/crossed-circle.svg'
import { ReactComponent as CrossedSquareIcon } from './icons/crossed-square.svg'
import { ReactComponent as GeometricIcon } from './icons/geometric-icon.svg'
import { ReactComponent as OvalIcon } from './icons/oval.svg'
import { ReactComponent as RectangleIcon } from './icons/rectangle.svg'
import { ReactComponent as RoundedRectangleIcon } from './icons/rounded-rectangle.svg'

import styles from './AnimatedHeader.module.css'

const AnimatedHeader = () => {
  const { firstName } = useAppSelector((state) => state.authStates)

  const firstLineContent = [
    {
      text: 'Hey',
      icon: ({ ...props }) => (
        <OvalIcon className={cx('w-10 sm:w-17 md:w-25')} {...props} />
      ),
    },
    {
      text: firstName,
      icon: ({ ...props }) => (
        <RectangleIcon className={cx('w-20 sm:w-30 md:w-36')} {...props} />
      ),
    },
  ]

  const secondLineContent = [
    {
      text: 'welcome',
      icon: ({ ...props }) => (
        <CrossedSquareIcon className={cx('w-25 sm:w-35 md:w-60')} {...props} />
      ),
    },
    {
      text: 'back',
      icon: ({ ...props }) => (
        <GeometricIcon className={cx('w-16 sm:w-22 md:w-32')} {...props} />
      ),
    },
    {
      text: 'to',
      icon: ({ ...props }) => (
        <CrossedCircleIcon className={cx('w-6 sm:w-10 md:w-14')} {...props} />
      ),
    },
    {
      text: 'Jacquard.',
      icon: ({ ...props }) => (
        <RoundedRectangleIcon
          className={cx('w-25 sm:w-40 md:w-60')}
          {...props}
        />
      ),
    },
  ]

  return (
    <div className={styles.container}>
      <div className={cx(styles.textWithIcons, styles.firstTextWithIcons)}>
        {firstLineContent.map(({ icon: Icon, text }, index) => (
          <div key={index} className={styles.word}>
            <div className={styles.textWrapper}>
              <div className={styles.iconWrapper}>
                <Icon isDefaultColor={false} />
              </div>
              <span className={styles.text}>{text}</span>
            </div>
          </div>
        ))}
      </div>
      <div className={cx(styles.textWithIcons, styles.secondTextWithIcons)}>
        {secondLineContent.map(({ icon: Icon, text }, index) => {
          return (
            <div key={index} className={styles.word}>
              <div className={styles.textWrapper}>
                <div className={styles.iconWrapper}>
                  <Icon isDefaultColor={false} />
                </div>
                <span className={styles.text}>{text}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AnimatedHeader
